export default  {
    generateShearPlate: '/api/web/v2/account/generateshearplate',
    getShearPlateInfo: '/api/web/v2/account/getshearplateinfo',
    shearPlateLogin: '/api/web/v2/account/shearplatelogin',
}
